import { parseApiError } from './apiError';

/**
 * Une ligne de la table `AuthFailure` : un échec de connexion Google ou Apple
 * signalé par l'app (POST /api/auth/failure). Souvent survenu avant tout appel
 * à l'API, il n'a donc pas de trace dans `api_logs`.
 */
export interface AuthFailureEntry {
  id: number;
  provider: 'google' | 'apple';
  /** sign_in : chez Google/Apple ; api : /api/auth/* ; register : création du compte. */
  stage: 'sign_in' | 'api' | 'register';
  reason: string;
  detail: string | null;
  signing_sha1: string | null;
  play_services: string | null;
  user_agent: string | null;
  ip: string | null;
  created_at: string;
}

export interface AuthFailuresFilters {
  provider?: string;
  reason?: string;
  limit: number;
}

export const getAuthFailures = async (token: string, filters: AuthFailuresFilters): Promise<AuthFailureEntry[]> => {
  const params = new URLSearchParams({ limit: String(filters.limit) });
  if (filters.provider) params.set('provider', filters.provider);
  if (filters.reason) params.set('reason', filters.reason);

  const res = await fetch(`${process.env.REACT_APP_API_URL}api/admin/auth-failures?${params}`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!res.ok) throw await parseApiError(res);
  const json = await res.json();
  return json.data ?? [];
};
